import { CatSkeleton } from '@blocks-react/components/Skeleton';
import PropTypes from 'prop-types';
import {
  XXL_BLOCKS_SKELETON_HEIGHT,
  BLOCKS_SKELETON_SIZES
} from '@app/constants/commonConstants';
import { v4 as uuid } from 'uuid';
import classnames from 'classnames';
import styles from './Skeleton.module.scss';

const Skeleton = ({ size, heightInPx, width = '100%', className }) => {
  const skeletonWidth = typeof width === 'number' ? `${width}px` : width;

  if ((!heightInPx && !className) || heightInPx <= 0) {
    return (
      <CatSkeleton
        width={skeletonWidth}
        data-testid="CatSkeletonWithSize"
        size={size}
      />
    );
  }

  if (!heightInPx) {
    return (
      <div
        className={classnames(styles['skeleton__container'], className)}
        style={{ width: skeletonWidth }}
        data-testid="CatSkeletonContainer"
      >
        <CatSkeleton size={size ?? 'xxl'} />
      </div>
    );
  }

  const numberOfSkeletons = Math.ceil(heightInPx / XXL_BLOCKS_SKELETON_HEIGHT); // Creating multiple CatSkeletons if required height is more than 384px as that's blocks tallest possible skeleton on current version (1.0.7)
  const catSeletonsArray = [...Array(numberOfSkeletons)];

  return (
    <div
      className={classnames(styles['skeleton__container'], className)}
      style={{ height: `${heightInPx}px`, width: skeletonWidth }}
      data-testid="CatSkeletonContainer"
    >
      {catSeletonsArray?.map(() => (
        <CatSkeleton
          key={'blocks-skeleton-' + uuid()}
          data-testid="CatSkeletonWithCustomHeight"
          size={size ?? 'xxl'}
        />
      ))}
    </div>
  );
};

Skeleton.propTypes = {
  size: PropTypes.oneOf(BLOCKS_SKELETON_SIZES),
  heightInPx: PropTypes.oneOfType([PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
};

export default Skeleton;
